import { Input, NgModule } from '@angular/core';
import {
  ActivatedRoute,
  ChildrenOutletContexts,
  RouterModule,
  RouterStateSnapshot,
  Routes,
} from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LandingComponent } from './pages/landing/landing.component';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SettingsComponent } from './components/settings/settings.component';
import { UnauthorisedComponent } from './components/unauthorised/unauthorised.component';
import { LogoutComponent } from './components/logout/logout.component';
import { SalesRealization } from './utils/SalesRealization';
import { MeritorComponent } from './modules/Components/pages/meritor/meritor.component';
import { DetailedMeritorViewComponent } from './modules/Components/pages/meritor/detailed-meritor-view/detailed-meritor-view.component';
import { CustomerLevelComponent } from './modules/Distribution/customer-level/customer-level.component';
import { PriceDeepDriveComponent } from './modules/power-systems/Engines/price-realization/price-deep-drive/price-deep-drive.component';
import { PriceRealizationComponent } from './modules/power-systems/Engines/price-realization/price-realization.component';
import { CesAfterMarketComponent } from './modules/Components/cummins-emission-solutions(CES)/ces-after-market/ces-after-market.component';
import { CesFirstFitComponent } from './modules/Components/cummins-emission-solutions(CES)/ces-first-fit/ces-first-fit.component';
import { CumminsSoftwareElectronicsComponent } from './modules/Components/cummins-software-electronics(CSE)/cummins-software-electronics/cummins-software-electronics.component';
import { SoftwareElectronicsComponent } from './modules/Components/cummins-engine-components(CEC)/software-electronics/software-electronics.component';
import { FuelSystemsComponent } from './modules/Components/cummins-engine-components(CEC)/fuel-systems/fuel-systems.component';
import { CecCttFirstFitComponent } from './modules/Components/cummins-engine-components(CEC)/cummins-turbo-technologies(CTT)/cec-ctt-first-fit/cec-ctt-first-fit.component';
import { CecCfsFirstFitComponent } from './modules/Components/cummins-engine-components(CEC)/cummins-fuel-system(CFS)/cec-cfs-first-fit/cec-cfs-first-fit.component';
import { JacobsVehicleSystemComponent } from './modules/Components/cummins-engine-components(CEC)/jacobs-vehicle-systems(JVS)/jacobs-vehicle-system/jacobs-vehicle-system.component';
import { ReportComponent } from './components/pages/Components/report/report.component';
import { RequestAccessComponent } from './components/request-access/request-access.component';


const routes: Routes = [
  {
    path: 'unauthorised',
    component: UnauthorisedComponent,
    data: { showNavbar: false, headerText: 'SALES REALIZATION' },
  },
  {
    path: 'request-access',
    component: RequestAccessComponent,
    data: { showNavbar: false, headerText: 'SALES REALIZATION' },
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    data: { showNavbar: false, headerText: 'SALES REALIZATION' },
  },
  {
    path: 'settings',
    component: SettingsComponent,
    data: { showNavbar: true, headerText: 'SALES REALIZATION' },
  },
  {
    path: 'reset-password',
    // { path: 'reset-password/:id', component: HeroDetailComponent }
    component: ResetPasswordComponent,
    data: { showNavbar: false, headerText: 'SALES REALIZATION' },
  },

  {
    path: '',
    component: LandingComponent,
    data: { showNavbar: false, headerText: '' },
    canActivate: [AuthGuard],
  },
  {
    path:'omni/dashboard',
    component: ReportComponent,
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/EBU/ebu.module').then((m) => m.EbuModule),
    canActivate: [AuthGuard],
    data: { showNavbar: true, headerText: 'SALES REALIZATION' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/Components/components.module').then(
        (m) => m.ComponentsModule
      ),
    data: { showNavbar: true, headerText: 'NRP SCORECARD' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/shared/shared.module').then((m) => m.SharedModule),
    canActivate: [AuthGuard],
    data: { showNavbar: true, headerText: '' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/power-systems/power-systems.module').then(
        (m) => m.PowerSystemsModule
      ),

    data: { showNavbar: true, headerText: 'HHP SCORECARD' },
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/Distribution/distribution.module').then(
        (m) => m.DistributionModule
      ),
    data: { showNavbar: true, headerText: 'CSSNA SCORECARD' },
    // canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/Overall/overall.module').then(
        (m) => m.OverallModule
      ),
    data: { showNavbar: true, headerText: 'OVERALL VIEW' },
    canActivate: [AuthGuard],
  },


  {
    path: 'meritor',
    loadChildren: () =>
      import('./modules/Components/pages/meritor/meritor.module').then(
        (m) => m.MeritorModule
      ),
    canActivate: [AuthGuard],
    data: { showNavbar: true, headerText: 'MeritorCummins Drivetrain and Braking Systems' },
  },

  {
    path: 'components/meritor',
    component: MeritorComponent,
    data: { showNavbar: true, headerText: 'Cummins Drivetrain and Braking Systems' },
  },

  {
    path: 'components/meritor/detailedMeritorView',
    component: DetailedMeritorViewComponent,
    data: { showNavbar: true, headerText: 'Cummins Drivetrain and Braking Systems' },
  },

  {
    path: 'price-realization',
    component: PriceRealizationComponent,
    data: { showNavbar: true, headerText: 'HHP PRICE REALIZATION' },
  },

  {
    path: 'price-deep-drive',
    component: PriceDeepDriveComponent,
    data: { showNavbar: true, headerText: 'HHP PRICE REALIZATION' },
  },

  {
    path: 'customerLevel',
    component: CustomerLevelComponent,
    data: { showNavbar: true, headerText: 'CSSNA CUSTOMER LEVEL REALIZATION' },
  },

  {
    path: 'ces-first-fit',
    component: CesFirstFitComponent,
    data: { showNavbar: true, headerText: 'CES FIRST FIT PAGE' },
  },

  {
    path: 'ces-after-market',
    component: CesAfterMarketComponent,
    data: { showNavbar: true, headerText: 'CES SCORECARD' },
  },

  {
    path: 'cummins-software-electronics',
    component: CumminsSoftwareElectronicsComponent,
    data: { showNavbar: true, headerText: 'CUMMINS SOFTWARE ELECTRONICS PAGE'}
  },

  {
    path: 'software-electronics',
    component: SoftwareElectronicsComponent,
    data: { showNavbar: true, headerText: 'SOFTWARE AND ELECTRONICS' }
  },

  {
    path: 'fuel-systems',
    component: FuelSystemsComponent,
    data: { showNavbar: true, headerText: 'FUEL SYSTEMS' }
  },

  {
    path: 'cec-ctt-first-fit',
    component: CecCttFirstFitComponent,
    data: { showNavbar: true, headerText: 'CTT BUSINESS' }
  },

  {
    path: 'cec-cfs-first-fit',
    component: CecCfsFirstFitComponent,
    data: { showNavbar: true, headerText: 'CEC CFS FRIST FIT PAGE' }
  },

  {
    path: 'jacobs-vehicle-systems',
    component: JacobsVehicleSystemComponent,
    data: { showNavbar: true, headerText: 'JACOBS VEHICLE SYSTEMS PAGE'}
  },

  {
    path: '**',
    redirectTo: '',
  },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor() {}
}
